<template>
  <div>
    <p>{{ label }} participant's schedule for event <strong>{{ details.event.name }}</strong></p>
    <ul class="list-unstyled object-details">
      <li>{{ details.presenter_data.first_event_start }}</li>
      <li v-if="details.presenter_data.first_event_end">{{ details.presenter_data.first_event_end }}</li>
      <li v-if="details.repeat_type">{{ details.presenter_data.repeats }} {{ details.presenter_data.last_event_end }}</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "StudyUserSchedule",
    props: {
      details: {
        type: Object,
        default: function () {
          return {};
        }
      },
      label: {
        type: String,
        default: "Related to"
      }
    },
  }
</script>

<style scoped>

</style>